import { Box } from "@mui/joy";
import MainLayout from "../layouts/MainLayout";
import CreatePlaceModal from "../components/place/popup/CreatePlaceModal";
import EditPlaceModal from "../components/place/popup/EditPlaceModal";
import ViewPlaceModal from "../components/place/popup/ViewPlaceModal";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMapBounds, setMapCenter, setMapZoom } from "../store";

function CorkageApp() {
  const dispatch = useDispatch();
  const currentMapBounds = useSelector((state) => state.map.mapBounds);
  const currentMapCenter = useSelector((state) => state.map.mapCenter);
  const currentMapZoom = useSelector((state) => state.map.mapZoom);

  // Initialize map with default values only on first mount or if values are not set
  useEffect(() => {
    // Only set default values if they haven't been set yet
    const boundsNotSet = !currentMapBounds ||
                         (currentMapBounds.north === 0 &&
                          currentMapBounds.south === 0 &&
                          currentMapBounds.east === 0 &&
                          currentMapBounds.west === 0);

    const centerNotSet = !currentMapCenter ||
                         (currentMapCenter.lat === 0 &&
                          currentMapCenter.lng === 0);

    // Set default map center if not already set
    if (centerNotSet) {
      dispatch(
        setMapCenter({
          lat: 34.0549076,
          lng: -118.242643,
        }),
      );
    }

    // Set default zoom if not already set or is 0
    if (currentMapZoom === 0) {
      dispatch(setMapZoom(12));
    }

    // Set initial map bounds only if not already set
    if (boundsNotSet) {
      dispatch(
        setMapBounds({
          north: 34.15,
          south: 33.95,
          east: -118.15,
          west: -118.35,
        }),
      );
    }
  }, [dispatch, currentMapBounds, currentMapCenter, currentMapZoom]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        position: "relative",
      }}
    >
      <MainLayout />

      {/* Modals */}
      <CreatePlaceModal />
      <EditPlaceModal />
      <ViewPlaceModal />
    </Box>
  );
}

export default CorkageApp;